// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_6oEcNPcNv3hn5mo6pB", // botw
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/cN22917Vs0l03wAdS3", // botw

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "Anime Game Style Art Gen f(x)",
    HOME_PAGE_TITLE: "Home - Anime Game Style Art Gen f(x)",
    DASHBOARD_PAGE_TITLE: "Home - Anime Game Style Art Gen f(x)",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to Anime Game Style Art Gen f(x)",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate anime video game style art, choose an image and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "botw_gen_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/botw-gen-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;